import { Component, Input, OnInit, Output, EventEmitter, IterableDiffers, DoCheck } from '@angular/core';
import { AngularAssignToolService } from 'src/app/reusables/assign-tool/angular-assign-tool.service';

@Component({
  selector: 'cv-add-edit-assign-box',
  templateUrl: './add-edit-assign-box.component.html',
  styleUrls: ['./add-edit-assign-box.component.scss']
})
export class AddEditAssignBoxComponent implements OnInit, DoCheck {
  @Input() lst: any[];
  @Input() showAll: boolean;
  @Input() empgrouptypes: any;
  @Input() recgrouptypes: any;
  @Input() datatransfer: any;
  @Input() type:any;

  @Output() onRemove: EventEmitter<any> = new EventEmitter<any>();

  search: string = "";
  empSelection = [];
  recSelection = [];
  selectAllEmp: boolean;
  selectAllRec: boolean;
  showAllItems: boolean;
  iterableDiffer;
  searchFilter: string = '';

  constructor(
    private iterableDiffers: IterableDiffers,
    private assignToolService: AngularAssignToolService
  ) {
    this.iterableDiffer = this.iterableDiffers.find([]).create(null);
    $(document).on('AssignToolGroupCountEvt', this.onGroupCount);
    $(document).on('AssignToolButtonEvt', this.onAssignToolButton);
  }

  ngOnInit(): void {
    /*setTimeout(() => {
      scroll bars here
      $(".objectivesBoxScroll").mCustomScrollbar({
          contentTouchScroll: 25,
          scrollInertia: 30,
          theme: "dark"
      });
  }, 0);*/
  }

  ngDoCheck(){
    let changes = this.iterableDiffer.diff(this.lst);

    if(changes){
      var empCount = 0;
      var recCount = 0;
      this.selectAllEmp = false;
      this.selectAllRec = false;

      if (this.lst.length > 0) {
        empCount = this.lst.filter((group) => { return group.BaseGroupType == 0; }).length;
        recCount = this.lst.filter((group) => { return group.BaseGroupType == 1; }).length;

        this.empSelection = new Array(empCount);
        this.empSelection.fill(false);
        this.recSelection = new Array(recCount);
        this.recSelection.fill(false);

        this.lst.forEach((element) => {
          element.checked = false;
        });
      } else {
        this.empSelection = [];
        this.recSelection = [];
      }
    }
  }

  empSelected(): boolean {
    for (var i = 0; i < this.lst.length; i++) {
      if (this.lst[i].BaseGroupType == 0) return true;
    }
    return false;
  }

  recSelected(): boolean {
    for (var i = 0; i < this.lst.length; i++) {
      if (this.lst[i].BaseGroupType == 1) return true;
    }
    return false;
  }

    checkSelection(type: string, group: any, index: number): void {
        // Find the original group in the main list based on its GroupID
        const originalGroup = this.lst.find(g => g.GroupID === group.GroupID);

        // Toggle the checked state of the original group if found
        if (originalGroup) {
            originalGroup.checked = !originalGroup.checked;
        }

        switch (type) {
            case 'emp':
                // Update the selection state for employee groups
                this.empSelection[index] = originalGroup ? originalGroup.checked : group.checked;
                this.selectAllEmp = this.empSelection.every(selected => selected);
                break;

            case 'rec':
                // Update the selection state for recipient groups
                this.recSelection[index] = originalGroup ? originalGroup.checked : group.checked;
                this.selectAllRec = this.recSelection.every(selected => selected);
                break;
        }
    }

  selection(type: string): void {
    switch (type) {
      case 'emp':
        this.empSelection.fill(this.selectAllEmp);
        this.lst.forEach((group) => {
          if (group.BaseGroupType == 0) {
            group.checked = this.selectAllEmp;
          }
        });
        break;
      case 'rec':
        this.recSelection.fill(this.selectAllRec);
        this.lst.forEach((group) => {
          if (group.BaseGroupType == 1) {
            group.checked = this.selectAllRec;
          }
        });
        break;
    }
  }

    updateSearchFilter(searchValue: string): void {
        this.searchFilter = searchValue;
        this.search = searchValue;

        // If the search field is empty, reset all selections
        if (!searchValue) {
            this.lst.forEach(group => {
                group.checked = false;
            });

            this.clearSearchFilter();
        } else {
            // If a search value is provided, uncheck items that do not match the filter
            this.lst.forEach(group => {
                if (!group.GroupName.toLowerCase().includes(searchValue.toLowerCase())) {
                    group.checked = false;
                }
            });
        }
    }

  enableDelete(): boolean {
    if (this.empSelection.includes(true) || this.recSelection.includes(true)) {
      return true;
    } else {
      return false;
    }
  }

    deleteGroups(): void {
        let selectedGroups: any[] = [];

        // If a search filter is active, select only the visible and checked items
        if (this.searchFilter) {
            selectedGroups = this.lst.filter(group =>
                group.GroupName.toLowerCase().includes(this.searchFilter.toLowerCase()) && group.checked
            );
        } else {
            // If no filter is applied, remove all selected items
            selectedGroups = this.lst.filter(group => group.checked);
        }

        // If "Select All" is active while a search filter is applied, only remove the filtered results
        if ((this.selectAllEmp || this.selectAllRec) && this.searchFilter) {
            selectedGroups = this.lst.filter(group =>
                group.GroupName.toLowerCase().includes(this.searchFilter.toLowerCase()) && group.checked
            );
        }

        // Emit selected groups to move them to the other list
        selectedGroups.forEach(group => {
            this.onRemove.emit(group);
            group.checked = false;
        });

        this.clearSearchFilter();
    }

  setHeight(): string {
    return this.lst.length == 0 ? '323px' : '281px';
  }
  
  //Events
  private onGroupCount = (data: any) => {
    if (data.parentGroup.GroupLevel == null || data.parentGroup.GroupLevel == 1) return;

    this.assignToolService.getGroupCount(data.parentGroup.GroupLevel, data.parentGroup.GroupID, data.parentGroup.BaseGroupType).then(
      (result) => {
        //Make sure this is returning a proper int and see if this reference will extend to the factor if I need to add it to lst.
        data.parentGroup.totalGroupCount = angular.copy(result);
      });
  };

  private onAssignToolButton = (data: any) => {
    //Double check with on desired save functionality
    if (!this.showAll) {    //require a selection for both emp and rec
      var empFound = false;
      var recFound = false;
      for (var i = 0; i < this.lst.length; i++) {
        if (this.lst[i].BaseGroupType == 0) {
          empFound = true;
        }
        else if (this.lst[i].BaseGroupType == 1) {
          recFound = true;
        }
        if (empFound && recFound) break;
      }

      if (empFound == false || recFound == false) {
        showErrorMessage("Please add an emp and rec group before assigning.", "Error, Groups are Required");
        return;
      }
    }

    const eventObj = {
      lst: this.lst
    }

    $(document).trigger(new jQuery.Event('AssignToolObjectiveSaveEvt', eventObj));
    return;
  }

    clearSearchFilter(): void {
        this.lst.forEach(group => group.checked = false);
        this.empSelection.fill(false);
        this.recSelection.fill(false);
        this.selectAllEmp = false;
        this.selectAllRec = false;
    }
}
